'use client';
import React, { useState, useEffect } from 'react';

const NAV_LINKS = [
  { label: 'Mission', href: '#hero' },
  { label: 'Data', href: '#data' },
  { label: 'Catalog', href: '#catalog' },
  { label: 'Team', href: '#team' },
  { label: 'Partners', href: '#partners' },
];

const INAT_URL = 'https://www.inaturalist.org/projects/north-texas-biodiversity-inventory-ntbi';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-forest/95 backdrop-blur-xl border-b border-white/10 py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo mark: 32px circle with "N" */}
        <a href="#" className="flex items-center gap-3 group">
          <div
            className="flex-shrink-0 flex items-center justify-center rounded-full"
            style={{
              width: 32,
              height: 32,
              backgroundColor: '#102E1D',
              border: '1.5px solid rgba(242,237,224,0.25)',
            }}
          >
            <span
              style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: 11,
                fontWeight: 600,
                color: '#F2EDE0',
                lineHeight: 1,
                letterSpacing: '-0.01em',
              }}
            >
              N
            </span>
          </div>
          <span
            className="hidden sm:block text-bone/90 group-hover:text-bone transition-colors"
            style={{
              fontFamily: "'Fraunces', serif",
              fontSize: 15,
              fontWeight: 500,
              letterSpacing: '-0.01em',
            }}
          >
            North Texas Biodiversity Inventory
          </span>
        </a>

        {/* Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="text-white/60 hover:text-white transition-colors"
              style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: 11,
                fontWeight: 500,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
              }}
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <a
          href={INAT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden sm:inline-flex items-center gap-2 px-5 py-2.5 rounded-full transition-all duration-200 hover:-translate-y-0.5"
          style={{
            backgroundColor: '#102E1D',
            border: '1.5px solid rgba(242,237,224,0.2)',
            color: '#F2EDE0',
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
          }}
        >
          <span>View on iNaturalist</span>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
            <path d="M2.5 9.5L9.5 2.5M9.5 2.5H4.5M9.5 2.5V7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>
      </div>
    </header>
  );
};

export default Header;